import { merge } from 'lodash';
import { defaultCategoryList } from './categoryList';
import { ImageResizeMode } from './imageResizeMode';
import { SearchDocumentType } from '@wix/client-search-sdk';
const BASE_API_URL = '/_api/app-settings-service';
export const API_URL_SETTINGS_INSTANCES = `${BASE_API_URL}/v1/settings/instances`;
export const defaultAppSettings = {
    categoryList: defaultCategoryList,
    productImageResizeMode: ImageResizeMode.Fit,
    isProductPriceVisible: true,
    isSeoHiddenIncluded: false,
};
export const createSettingsClient = ({ httpClient, disableAllTabByDefault = false, }) => {
    const getDefault = () => disableAllTabByDefault
        ? Object.assign(Object.assign({}, defaultAppSettings), { categoryList: Object.assign(Object.assign({}, defaultAppSettings.categoryList), { [SearchDocumentType.All]: {
                    index: 100,
                    visible: false,
                    useOverride: false,
                    override: '',
                } }) }) : Object.assign({}, defaultAppSettings);
    const get = async (state) => {
        try {
            const { data } = await httpClient.get(API_URL_SETTINGS_INSTANCES, {
                params: {
                    state,
                    host: 'VIEWER',
                },
            });
            return merge({}, getDefault(), data.settings);
        }
        catch (e) {
            return getDefault();
        }
    };
    const set = async (key, value) => {
        await httpClient.patch(API_URL_SETTINGS_INSTANCES, {
            settings: { [key]: value },
            host: 'VIEWER',
            states: ['SAVED'],
        });
    };
    return {
        getSaved: () => get('SAVED'),
        getPublished: () => get('PUBLISHED'),
        getDefault: async () => getDefault(),
        set,
    };
};
//# sourceMappingURL=settingsClient.js.map